var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.ifShow
    ? _c(
        "div",
        {
          staticClass: "buyNowMain",
          on: {
            click: function($event) {
              if ($event.target !== $event.currentTarget) {
                return null
              }
              return _vm.removeDialog($event)
            }
          }
        },
        [
          _c("div", { staticClass: "frame" }, [
            _c("div", { staticClass: "shopName" }, [
              _vm._v("店铺：" + _vm._s(_vm.shopInfo.supplierInfo.name))
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "pricePrompt" }, [
              _vm._v("请输入核销金额：")
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "priceInputWrapper" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.price,
                    expression: "price"
                  }
                ],
                attrs: { type: "number", min: "0.1" },
                domProps: { value: _vm.price },
                on: {
                  blur: _vm.priceInputBlur,
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.price = $event.target.value
                  }
                }
              }),
              _vm._v(" "),
              _c("div", { staticClass: "divider" }),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "clearText",
                  on: {
                    click: function($event) {
                      _vm.price = ""
                    }
                  }
                },
                [_vm._v("清除")]
              )
            ]),
            _vm._v(" "),
            _c(
              "button",
              { staticClass: "payButton", on: { click: _vm.payNow } },
              [_vm._v("立即支付")]
            )
          ]),
          _vm._v(" "),
          _c("i", {
            staticClass: "iconfont icon-close2",
            staticStyle: {
              color: "#ffffff",
              "font-size": "0.35rem",
              "margin-top": "0.21rem"
            },
            on: { click: _vm.removeDialog }
          })
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }